module.exports = __webpack_public_path__ + "img/fr.823dd4b3.svg";